import React from "react";
import { Col, Row } from "react-bootstrap";
import { SliderPage } from ".";
import { SIGN_SAMPLES } from "../assets/images/samples";
import { BlockCheckbox, Notes } from "../components/fields";
import AddOnSection from "../components/order/AddOnSection";
import { useWatch } from "react-hook-form";
import { SIGN_DISCOUNT_SKUS } from "../helpers/constants";
import { toCurrency } from "../helpers";
import { useProduct } from "../adapters/uplist";

export const SignPage = () => {
  const discount_products = useWatch({ name: SIGN_DISCOUNT_SKUS });
  const has_sign_products = discount_products.filter(Boolean).length >= 3;
  const { data: product } = useProduct("8001");
  const { data: discount_product } = useProduct("8002");

  const discount =
    has_sign_products && toCurrency(product.price + discount_product.price);
  return (
    <SliderPage title="Signs">
      <Row>
        <BlockCheckbox
          sku="8001"
          modal={{ urls: SIGN_SAMPLES }}
          discount={discount}
        />
      </Row>
      <AddOnSection show_skus={["8001"]}>
        <Row>
          <Col md={6}>
            <Notes
              name="notes.sign"
              label="Please let us know any details about the sign installation."
            />
          </Col>
        </Row>
      </AddOnSection>
    </SliderPage>
  );
};
